/** Straße, Hausnummer und Zusatz. „Nordring“ + „2“ + „I“ → „Nordring 2 I“. */
export function composeStreetLine(person) {
  if (!person) return '';
  return ['street', 'house_number', 'address_extra']
    .map((key) => String(person[key] ?? '').replace(/\s+/g, ' ').trim())
    .filter(Boolean)
    .join(' ');
}

/** „Nordring 2 I, 48455 Bad Bentheim“. */
export function composePostalAddress(person) {
  if (!person) return '';
  const street = composeStreetLine(person);
  const place = [person.postal_code, person.city]
    .map((value) => String(value ?? '').replace(/\s+/g, ' ').trim())
    .filter(Boolean)
    .join(' ');
  return [street, place].filter(Boolean).join(', ');
}
